import { useCallback } from 'react';
import { message } from 'antd';
import useDeleteShoppingItemMutation from "../../../../queries/useDeleteShoppingItemMutation";
import { CartTableItem } from '../../../../types/home';

export default function useDeleteCartItem(
  prepareData: (showPendingItems: boolean) => Promise<void>,
  setRowLoading: (orderId: string, isLoading: boolean) => void
) {
  const deleteShoppingItemMutation = useDeleteShoppingItemMutation();

  const deleteItem = useCallback(async (item: CartTableItem) => {
    setRowLoading(item.orderId, true);

    setTimeout(async () => {
      try {
        const response = await deleteShoppingItemMutation.mutateAsync(item.orderId);
        if (response) {
          await prepareData(true);
        } else {
          message.error('Failed to remove!');
          setRowLoading(item.orderId, false);
        }
      } catch (error) {
        message.error('Failed to remove!');
        setRowLoading(item.orderId, false);
      }
    }, 1000);
  }, [deleteShoppingItemMutation, prepareData, setRowLoading]);

  return {
    deleteItem,
    isDeleting: deleteShoppingItemMutation.isPending
  };
}
